var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    fillRule: "evenodd",
    d: "M18.86 6.37c.76.2 1.37.81 1.57 1.58.37 1.4.37 4.3.37 4.3s0 2.9-.37 4.3c-.2.77-.8 1.37-1.57 1.58-1.4.37-6.96.37-6.96.37s-5.57 0-6.95-.37a2.23 2.23 0 0 1-1.58-1.58C3 15.15 3 12.25 3 12.25s0-2.9.37-4.3c.2-.77.81-1.37 1.58-1.58C6.33 6 11.9 6 11.9 6s5.57 0 6.96.37Zm-4.13 5.88-4.65 2.64V9.6l4.65 2.64Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube24);
export default __webpack_public_path__ + "static/media/youtube_24.671b086adc7126420342753f3ea74dcc.svg";
export { ForwardRef as ReactComponent };